import React, { useCallback, useEffect, useState } from 'react';
import { CustomEventName } from '@mb/lib';
import { NylasScheduling } from '@nylas/react';
import * as Styled from './SchedulingModal.styles';
import { getNylasCalendarModalConfig } from '../../helpers';
import { NylasConfig } from '../../types';

export const SchedulingModal = () => {
  const [title, setTitle] = useState('');
  const [open, setOpen] = useState(false);
  const [nylasConfig, setNylasConfig] = useState<NylasConfig | null>(null);
  const nylasDefaultConfig = getNylasCalendarModalConfig();
  const showCloseIcon = true;

  useEffect(() => {
    window.addEventListener(
      CustomEventName.OPEN_BOOK_MEETING_DIALOG,
      handleOpen,
    );

    return () => {
      window.removeEventListener(
        CustomEventName.OPEN_BOOK_MEETING_DIALOG,
        handleOpen,
      );
    };
  }, []);

  const handleOpen = useCallback((event: CustomEvent) => {
    const { detail } = event;

    if (detail?.config_id) {
      setNylasConfig({
        configId: detail?.config_id,
        domain: nylasDefaultConfig?.domain,
      });
      setTitle(detail?.manufacturer_name);
      setOpen(true);
    }
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Styled.SchedulingDialog
        open={open}
        onClose={onClose}
        dialogWidth={850}
        leftButtonVariant="contained"
        leftButtonDense={false}
        leftButtonColor="secondary"
        mobileFullscreen={true}
        showCloseIcon={showCloseIcon}
      >
        <Styled.Title>{title}</Styled.Title>

        <NylasScheduling
          configurationId={nylasConfig?.configId}
          schedulerApiUrl={nylasConfig?.domain}
          enableUserFeedback={false}
        />
      </Styled.SchedulingDialog>
    </>
  );
};
